import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';
import { z } from 'zod';

countries.registerLocale(enLocale);

export const countryOptions = Object.entries(
  countries.getNames('en', { select: 'official' })
).map(([code, name]) => ({
  value: name,
  label: name,
  code: countries.alpha2ToAlpha3(code)
}));

const countryNames = countryOptions.map((option) => option.value);

export enum EInitProjectFormTeamSize {
  ONE_TO_FIVE = '1-5',
  SIX_TO_TEN = '6-10',
  ELEVEN_TO_FIFTY = '11-50',
  FIFTY_PLUS = '50+'
}

export enum EInitProjectFormAnnualRevenue {
  ZERO_TO_50K = '$0-50K',
  FIFTY_TO_100K = '$50K-100K',
  HUNDRED_TO_500K = '$100K-500K',
  FIVEHUNDRED_TO_1M = '$500K-1M',
  ONE_M_PLUS = '$1M+'
}

export const TEAM_SIZE_OPTIONS = [
  {
    value: EInitProjectFormTeamSize.ONE_TO_FIVE,
    label: EInitProjectFormTeamSize.ONE_TO_FIVE
  },
  {
    value: EInitProjectFormTeamSize.SIX_TO_TEN,
    label: EInitProjectFormTeamSize.SIX_TO_TEN
  },
  {
    value: EInitProjectFormTeamSize.ELEVEN_TO_FIFTY,
    label: EInitProjectFormTeamSize.ELEVEN_TO_FIFTY
  },
  {
    value: EInitProjectFormTeamSize.FIFTY_PLUS,
    label: EInitProjectFormTeamSize.FIFTY_PLUS
  }
];

export const ANNUAL_REVENUE_OPTIONS = [
  {
    value: '',
    label: 'None'
  },
  {
    value: EInitProjectFormAnnualRevenue.ZERO_TO_50K,
    label: EInitProjectFormAnnualRevenue.ZERO_TO_50K
  },
  {
    value: EInitProjectFormAnnualRevenue.FIFTY_TO_100K,
    label: EInitProjectFormAnnualRevenue.FIFTY_TO_100K
  },
  {
    value: EInitProjectFormAnnualRevenue.HUNDRED_TO_500K,
    label: EInitProjectFormAnnualRevenue.HUNDRED_TO_500K
  },
  {
    value: EInitProjectFormAnnualRevenue.FIVEHUNDRED_TO_1M,
    label: EInitProjectFormAnnualRevenue.FIVEHUNDRED_TO_1M
  },
  {
    value: EInitProjectFormAnnualRevenue.ONE_M_PLUS,
    label: EInitProjectFormAnnualRevenue.ONE_M_PLUS
  }
];

export const INIT_PROJECT_FORM_SCHEMA = z.object({
  businessName: z
    .string()
    .min(1, { message: 'Business name is required.' })
    .regex(/^[a-zA-Z\s'-]+$/, {
      message: 'Please provide a valid business name'
    }),
  websiteUrl: z
    .string()
    .min(1, { message: 'This field is required.' })
    .url({ message: 'Please enter a valid URL (e.g., https://example.com).' })
    .refine((val) => val.startsWith('https://'), {
      message: 'URL must start with https://'
    }),
  teamSize: z.nativeEnum(EInitProjectFormTeamSize),
  country: z.enum(countryNames as [string, ...string[]], {
    message: 'This field is required.'
  }),
  annualRevenue: z
    .nativeEnum(EInitProjectFormAnnualRevenue)
    .optional()
    .or(z.literal(''))
});
